/* Lucía de Miguel Edit · comportamiento: paneles, condiciones, caducidad de campaña, búsqueda predictiva,
   contador del carrito, pestañas Mujer/Hombre del menú, «Comprar el look» y formulario de comunidad. */
(() => {
  if (window.__veInit) return;
  window.__veInit = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const cfg = (() => { try { return JSON.parse($('[data-ve-search-config]').textContent); } catch (e) { return {}; } })();
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const money = (cents) => (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Paneles (menú, búsqueda) con foco atrapado ---------- */
  let openPanel = null, lastTrigger = null;
  const focusables = (el) => $$('a[href], button:not([disabled]), input:not([type=hidden]), select, textarea, [tabindex]:not([tabindex="-1"])', el).filter((n) => n.offsetParent !== null);
  function open(id, trigger) {
    const p = document.getElementById(id);
    if (!p) return;
    if (openPanel && openPanel !== p) close(false);
    lastTrigger = trigger || document.activeElement;
    p.hidden = false;
    openPanel = p;
    document.documentElement.classList.add('ve-lock');
    $$(`[data-ve-open="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const first = id === 've-search' ? $('[data-ve-q]', p) : focusables(p)[0];
    if (first) first.focus();
  }
  function close(restore = true) {
    if (!openPanel) return;
    $$(`[data-ve-open="${openPanel.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    openPanel.hidden = true;
    openPanel = null;
    document.documentElement.classList.remove('ve-lock');
    if (restore && lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-ve-open]');
    if (o) { e.preventDefault(); open(o.dataset.veOpen, o); return; }
    const s = e.target.closest('[data-ve-swap]');
    if (s) { e.preventDefault(); const t = lastTrigger; close(false); open(s.dataset.veSwap, t); return; }
    if (e.target.closest('[data-ve-close]')) { e.preventDefault(); close(); return; }
    const t = e.target.closest('[data-ve-toggle]');
    if (t) {
      const el = document.getElementById(t.dataset.veToggle);
      if (!el) return;
      el.hidden = !el.hidden;
      $$(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute('aria-expanded', String(!el.hidden)));
      if (!el.hidden) { const f = focusables(el)[0]; if (f) f.focus(); }
      else { const c = $(`[aria-controls="${el.id}"]`); if (c) c.focus(); }
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const pop = $$('.ve-bar__pop').find((p) => !p.hidden);
      if (pop) { pop.hidden = true; const c = $(`[aria-controls="${pop.id}"]`); if (c) { c.setAttribute('aria-expanded', 'false'); c.focus(); } return; }
      if (openPanel) close();
    }
    if (e.key === 'Tab' && openPanel) {
      const f = focusables(openPanel);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* ---------- Pestañas Mujer / Hombre del menú (no redirigen) ---------- */
  const tabs = $$('[data-ve-world-tab]');
  function showWorld(w, focus) {
    tabs.forEach((t) => {
      const on = t.dataset.veWorldTab === w;
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    $$('[data-ve-world]').forEach((p) => { p.hidden = p.dataset.veWorld !== w; });
    const menu = $('#ve-menu');
    if (menu) { menu.dataset.veMenuWorld = w; menu.classList.remove('is-swap'); void menu.offsetWidth; menu.classList.add('is-swap'); }
  }
  tabs.forEach((t) => {
    t.addEventListener('click', () => showWorld(t.dataset.veWorldTab));
    t.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); showWorld(t.dataset.veWorldTab === 'women' ? 'men' : 'women', true); }
    });
  });
  if (tabs.length) {
    const cur = $('.ve-hd__worlds [aria-current="page"]');
    showWorld(cur && cur === $$('.ve-hd__worlds a')[1] ? 'men' : (/hombre|men/i.test(location.pathname) && !/women/i.test(location.pathname) ? 'men' : 'women'));
  }

  /* ---------- Caducidad de campañas (por si la página llega desde caché) ---------- */
  $$('[data-ve-end]').forEach((el) => {
    const end = Date.parse(el.dataset.veEnd || '');
    if (!isNaN(end) && Date.now() >= end) {
      el.hidden = true;
      el.style.display = 'none';
      const fb = el.dataset.veFallback && $(el.dataset.veFallback);
      if (fb) fb.hidden = false;
    }
  });

  /* ---------- Búsqueda predictiva ---------- */
  const q = $('[data-ve-q]');
  if (q) {
    const wrap = $('[data-ve-results-wrap]'), list = $('[data-ve-results]'), empty = $('[data-ve-empty]'), loading = $('[data-ve-loading]'), all = $('[data-ve-all]');
    let timer = 0, ctrl = null;
    const reset = () => { wrap.hidden = true; list.innerHTML = ''; };
    const render = (products, term) => {
      loading.hidden = true;
      all.href = `${cfg.search || root + 'search'}?q=${encodeURIComponent(term)}&options%5Bprefix%5D=last`;
      if (!products.length) { empty.hidden = false; all.hidden = true; list.innerHTML = ''; return; }
      empty.hidden = true; all.hidden = false;
      list.innerHTML = products.slice(0, 5).map((p) => {
        const img = p.image ? `<img src="${esc(p.image)}${p.image.includes('?') ? '&' : '?'}width=500" alt="" loading="lazy">` : '';
        const price = p.price ? `<span class="ve-rcard__price">${esc(p.price_min && p.price_max && p.price_min !== p.price_max ? 'Desde ' : '')}${esc(money(Math.round(parseFloat(p.price) * 100)))}</span>` : '';
        return `<a class="ve-rcard" href="${esc(p.url)}"><span class="ve-rcard__img">${img}</span><span class="ve-rcard__info"><span class="ve-display ve-rcard__title">${esc(p.title)}</span>${price}<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M7 17 17 7M8 7h9v9"/></svg></span></a>`;
      }).join('');
    };
    const run = () => {
      const term = q.value.trim();
      if (term.length < 2) { reset(); return; }
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      wrap.hidden = false; loading.hidden = false; empty.hidden = true; all.hidden = true; list.innerHTML = '';
      const url = `${cfg.url || root + 'search/suggest'}.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
      fetch(url, { signal: ctrl.signal })
        .then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then((d) => render(((d.resources || {}).results || {}).products || [], term))
        .catch((err) => {
          if (err.name === 'AbortError') return;
          loading.hidden = true;
          list.innerHTML = `<p class="ve-search__empty" role="alert">No hemos podido cargar sugerencias. Pulsa Intro para ver los resultados.</p>`;
        });
    };
    q.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 220); });
    const clear = $('[data-ve-clear]');
    if (clear) clear.addEventListener('click', () => { q.value = ''; reset(); q.focus(); });
  }

  /* ---------- Contador del carrito ---------- */
  function setCount(n) {
    $$('[data-ve-count]').forEach((c) => { c.textContent = n; c.hidden = !n; });
    $$('[data-ve-cart-link]').forEach((a) => a.setAttribute('aria-label', `Carrito (${n} ${n === 1 ? 'artículo' : 'artículos'})`));
  }
  function refreshCount() {
    return fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json()).then((c) => { setCount(c.item_count); return c; }).catch(() => null);
  }
  ['cart:update', 'cart:updated', 'cart:refresh'].forEach((ev) => document.addEventListener(ev, () => setTimeout(refreshCount, 150)));
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCount(); });
  // Horizon actualiza el carrito con fetch: si cambia, se refresca el contador.
  const _fetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = _fetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(() => setTimeout(refreshCount, 100)).catch(() => {});
    return p;
  };

  /* ---------- Comprar el look ---------- */
  $$('[data-ve-look]').forEach((look) => {
    const selects = $$('[data-ve-look-select]', look), btn = $('[data-ve-look-add]', look), msg = $('[data-ve-look-msg]', look);
    if (!btn) return;
    const label = btn.innerHTML;
    const chosen = () => selects.filter((s) => s.value);
    const update = () => {
      const n = chosen().length;
      btn.disabled = n === 0;
      btn.innerHTML = n === 0 ? label : label.replace(/Elige las opciones del look/, n === selects.length ? 'Añadir el look al carrito' : `Añadir ${n} ${n === 1 ? 'prenda' : 'prendas'} al carrito`);
      msg.className = 've-look__msg';
      msg.textContent = n === 0 ? 'Selecciona talla o variante en cada prenda que quieras añadir.' : `${n} de ${selects.length} seleccionadas.`;
    };
    selects.forEach((s) => s.addEventListener('change', update));
    btn.addEventListener('click', () => {
      const items = chosen().map((s) => ({ id: Number(s.value), quantity: 1 }));
      if (!items.length) return;
      btn.disabled = true; btn.setAttribute('aria-busy', 'true');
      msg.className = 've-look__msg'; msg.textContent = 'Añadiendo…';
      _fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
        .then((r) => r.json().then((d) => ({ ok: r.ok, d })))
        .then(({ ok, d }) => {
          btn.removeAttribute('aria-busy');
          if (!ok) throw new Error('No hemos podido añadir el look: alguna talla ya no está disponible. Revisa la selección e inténtalo de nuevo.');
          msg.className = 've-look__msg is-ok';
          msg.innerHTML = `Añadido al carrito. <a href="${esc(cfg.cart || root + 'cart')}">Ver carrito</a>`;
          refreshCount().then((c) => { if (c) document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: c, sourceId: 've-look', data: { source: 've-look', itemCount: c.item_count } } })); });
          btn.disabled = false;
        })
        .catch((err) => {
          btn.removeAttribute('aria-busy'); btn.disabled = false;
          msg.className = 've-look__msg is-err';
          msg.textContent = err.message || 'No se pudo añadir. Inténtalo de nuevo.';
        });
    });
    update();
  });

  /* ---------- Comunidad: validación y etiqueta de interés ---------- */
  $$('form[data-ve-news], form.ve-news__form').forEach((f) => {
    const email = $('input[type=email]', f), consent = $('[data-ve-consent]', f), msg = $('[data-ve-news-msg]', f), tags = $('[data-ve-tags]', f);
    if (!email) return;
    f.addEventListener('change', (e) => {
      if (e.target.matches('[data-ve-interest]') && tags) tags.value = `${tags.dataset.base}, interes-${e.target.value}`;
    });
    f.addEventListener('submit', (e) => {
      let err = '';
      if (!email.value.trim()) err = 'Escribe tu email.';
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) err = 'Revisa el email: el formato no es válido.';
      else if (consent && !consent.checked) err = 'Marca la casilla para aceptar recibir emails.';
      if (err) {
        e.preventDefault();
        if (msg) msg.textContent = err;
        const bad = !email.value.trim() || err.startsWith('Revisa') ? email : consent;
        email.setAttribute('aria-invalid', String(bad === email));
        email.setAttribute('aria-describedby', msg ? msg.id : '');
        bad.focus();
      } else if (msg) msg.textContent = '';
    });
  });

  /* ---------- Foco en confirmaciones tras enviar formularios ---------- */
  const ok = $('[data-ve-focus]');
  if (ok) { ok.scrollIntoView({ block: 'center' }); ok.focus({ preventScroll: true }); }
  /* ---------- Tarjetas: puntos de posición al deslizar y muestras de color (Lucía de Miguel y Horizon) ---------- */
  const syncDots = (track, dots) => {
    const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
    return i;
  };
  const bindCard = (card) => {
    if (card.__ve) return; card.__ve = true;
    const track = $('[data-ve-track]', card), dots = $$('.ve-card__dots i', card), sws = $$('[data-ve-goto]', card);
    if (!track) return;
    let t;
    track.addEventListener('scroll', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const i = syncDots(track, dots);
        card.classList.add('is-swiped');
        sws.forEach((b) => b.classList.toggle('is-on', Number(b.dataset.veGoto) === i));
      }, 60);
    }, { passive: true });
    if (dots.length > 1) {
      ['prev', 'next'].forEach((d) => {
        const a = document.createElement('button');
        a.type = 'button'; a.className = 've-card__arrow ve-card__arrow--' + d; a.tabIndex = -1; a.setAttribute('aria-hidden', 'true');
        a.addEventListener('click', (e) => { e.preventDefault(); track.scrollBy({ left: (d === 'next' ? 1 : -1) * track.clientWidth, behavior: 'smooth' }); });
        track.parentElement.appendChild(a);
      });
    }
    sws.forEach((b) => b.addEventListener('click', (e) => {
      e.preventDefault();
      track.scrollTo({ left: Number(b.dataset.veGoto) * track.clientWidth, behavior: 'smooth' });
    }));
  };
  const bindHorizonCard = (card) => {
    if (card.__ve) return; card.__ve = true;
    const slides = $('slideshow-slides', card), media = $('.card-gallery', card);
    if (!slides || !media) return;
    const n = $$('slideshow-slide', slides).length;
    if (n < 2) return;
    const wrap = document.createElement('span');
    wrap.className = 've-card__dots ve-card__dots--hz'; wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML = '<i class="is-on"></i>'.concat('<i></i>'.repeat(Math.min(n, 8) - 1));
    media.appendChild(wrap);
    const hint = document.createElement('span');
    hint.className = 've-card__swipe'; hint.setAttribute('aria-hidden', 'true'); hint.textContent = 'Desliza';
    media.appendChild(hint);
    media.classList.add('ve-has-dots');
    const dots = $$('i', wrap);
    let t;
    slides.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => { syncDots(slides, dots); media.classList.add('is-swiped'); }, 60); }, { passive: true });
  };
  const scanCards = (r = document) => { $$('[data-ve-card]', r).forEach(bindCard); $$('product-card', r).forEach(bindHorizonCard); };
  scanCards();
  new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && scanCards(n)))).observe(document.body, { childList: true, subtree: true });

  /* ---------- Ficha: «¿Dudas con la talla?» abre la tabla de tallas (diálogo de la foto o, si no hay, el acordeón) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-ve-open-sizes]');
    if (!b) return;
    const sg = $('.vrs-sgb__btn');
    if (sg) { sg.click(); return; }
    const sum = $$('.product-details summary, details summary').find((s) => /gu[ií]a de tallas|tallas/i.test(s.textContent));
    if (sum) { sum.parentElement.open = true; sum.scrollIntoView({ behavior: 'smooth', block: 'center' }); sum.focus({ preventScroll: true }); }
  });

  /* ---------- Opiniones: pestañas prenda / envío ---------- */
  $$('[data-ve-tabs]').forEach((list) => {
    const tabs = $$('[role=tab]', list);
    const pick = (tab) => tabs.forEach((x) => {
      const on = x === tab;
      x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1;
      const p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on;
    });
    tabs.forEach((x, i) => {
      x.addEventListener('click', () => pick(x));
      x.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const nx = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]; pick(nx); nx.focus();
      });
    });
  });

  /* ---------- Regalo de bienvenida: icono + caja sorpresa a los X s (una vez por sesión) ---------- */
  $$('[data-ve-gift]').forEach((g) => {
    const dlg = $('dialog', g), fab = $('[data-ve-gift-open]', g), urg = $('[data-ve-gift-urg]', g);
    const store = (k, v) => { try { if (v === undefined) return localStorage.getItem(k) || sessionStorage.getItem(k); (k.startsWith('s:') ? sessionStorage : localStorage).setItem(k, v); } catch (e) { return null; } };
    if (!dlg || /\/(cart|checkouts?)\b/.test(location.pathname)) { g.hidden = true; return; }
    const end = g.dataset.end ? new Date(g.dataset.end) : null;
    if (end && !isNaN(end)) {
      const now = new Date();
      if (end < now) { g.hidden = true; return; }
      const sameDay = end.toDateString() === now.toDateString();
      urg.textContent = sameDay ? `Solo hoy · hasta las ${end.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}` : `Hasta el ${end.toLocaleDateString('es-ES', { day: 'numeric', month: 'long' })}`;
      urg.hidden = false;
    }
    const open = (auto) => {
      if (dlg.open) return;
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      g.classList.add('is-open');
      requestAnimationFrame(() => setTimeout(() => dlg.classList.add('is-unboxed'), 60));
      store('s:ve-gift-seen', '1');
      if (!auto) { const f = $('[data-ve-gift-step]:not([hidden]) input[type=email], [data-ve-gift-step]:not([hidden]) .ve-gift__copy', g); if (f) f.focus(); }
    };
    /* Código solo tras el alta real (BIENVENIDA10 es para suscriptores sin pedidos) */
    const showCode = () => { $$('[data-ve-gift-step]', g).forEach((s) => { s.hidden = s.dataset.veGiftStep !== 'code'; }); };
    const posted = $('[data-ve-gift-posted]', g);
    if (posted) store('ve-gift-unlocked', '1');
    if (g.hasAttribute('data-unlocked') || store('ve-gift-unlocked')) showCode();
    const form = $('.ve-gift__form', g);
    if (form) form.addEventListener('submit', (e) => {
      const mail = $('input[type=email]', form), ok = $('[data-ve-gift-consent]', form), err = $('[data-ve-gift-err]', form);
      let msg = '';
      if (!mail.value || !mail.checkValidity()) msg = 'Escribe un email válido.';
      else if (!ok.checked) msg = 'Marca la casilla para recibir el código por suscripción.';
      if (msg) { e.preventDefault(); err.textContent = msg; (msg.startsWith('Escribe') ? mail : ok).focus(); }
    });
    const close = () => { dlg.classList.remove('is-unboxed'); if (dlg.open) dlg.close(); g.classList.remove('is-open'); store('ve-gift-closed', String(Date.now())); };
    fab.addEventListener('click', () => open(false));
    $('[data-ve-gift-close]', g).addEventListener('click', close);
    dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); });
    dlg.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
    $('[data-ve-gift-copy]', g).addEventListener('click', (e) => {
      const done = () => { e.target.textContent = 'Copiado'; setTimeout(() => { e.target.textContent = 'Copiar'; }, 2000); };
      if (navigator.clipboard) navigator.clipboard.writeText(g.dataset.code).then(done, done); else done();
    });
    const closed = Number(store('ve-gift-closed') || 0);
    const recent = Date.now() - closed < 7 * 864e5;
    if (posted || $('.ve-gift__form [aria-invalid]', g)) open(false);
    else if (!store('s:ve-gift-seen') && !recent) setTimeout(() => { if (!document.querySelector('dialog[open]:not(.ve-gift__dialog)')) open(true); }, (Number(g.dataset.delay) || 15) * 1000);
  });
})();
